module.exports = __webpack_public_path__ + "static/img/4.e45fdb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/4.png
// module id = fNip
// module chunks = 0